import * as zod from 'zod';

import {
  RobotControlModeKindEnum,
  BrakesStateStateEnum,
} from '@sb/sb-robot-sdk/src/codegen/typescript-axios';

export const StandardBotsRO1Command = zod.object({
  kind: zod.literal('StandardBotsRO1Command'),
  deviceID: zod.string().optional(),
  subCommand: zod.discriminatedUnion('kind', [
    zod.object({
      kind: zod.literal('setControlMode'),
      controlMode: zod.nativeEnum(RobotControlModeKindEnum),
    }),
    zod.object({
      kind: zod.literal('recover'),
    }),
    zod.object({
      kind: zod.literal('setBrakesState'),
      state: zod.nativeEnum(BrakesStateStateEnum),
    }),
  ]),
});

export type StandardBotsRO1Command = zod.infer<typeof StandardBotsRO1Command>;
